import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import toast from "react-hot-toast";
import { Save, Globe, Phone, Share2, Loader2 } from "lucide-react";

export default function SiteSettingsPage() {
  const [formData, setFormData] = useState({
    siteUrl: "",
    isActive: false,
    turkish: false,
    english: false,
    arabic: false,
    french: false,
    german: false,
    phoneNumber: "",
    whatsappNumber: "",
    mailTo: "",
    location: "",
    isServiceHasImage: false,
    isBlogCategoryOn: false,
    isInstagramOn: false,
    instagramUrl: "",
    isFacebookOn: false,
    facebookUrl: "",
    isTwitterOn: false,
    twitterUrl: "",
    isLinkedinOn: false,
    linkedinUrl: "",
    isYoutubeOn: false,
    youtubeUrl: "",
    isWhatsappOn: false,
    isTiktokOn: false,
    tiktokUrl: "",
    isGithubOn: false,
    githubUrl: "",
    isBehanceOn: false,
    behanceUrl: "",
    isDribbbleOn: false,
    dribbbleUrl: "",
    isDiscordOn: false,
    discordUrl: "",
    isMediumOn: false,
    mediumUrl: "",
    isPinterestOn: false,
    pinterestUrl: "",
    isSkypeOn: false,
    skypeUrl: "",
    isTelegramOn: false,
    telegramUrl: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get("/setting");
        setFormData((prev) => ({ ...prev, ...res.data }));
      } catch (err) {
        toast("Henüz ayar bulunamadı. Yeni ayar oluşturabilirsiniz.", {
          icon: "⚠️",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await api.put("/setting", formData);
      toast.success("Ayarlar başarıyla güncellendi");
      setFormData(res.data);
    } catch (err) {
      if (err.response?.status === 404) {
        const createRes = await api.post("/setting", formData);
        toast.success("Ayarlar başarıyla oluşturuldu");
        setFormData(createRes.data);
      } else {
        toast.error("Ayarlar kaydedilirken hata oluştu");
      }
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="page-loading">
        <div className="loading-spinner" />
        <p>Yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Site Ayarları</h2>
          <p className="page-subtitle">İletişim bilgileri ve sosyal medya ayarları</p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="settings-grid">
          {/* İletişim Ayarları */}
          <div className="content-card full-width">
            <div className="card-section-header">
              <Phone size={20} />
              <h3>İletişim Bilgileri</h3>
            </div>

            <div className="form-row">
              <div className="form-field">
                <label>Telefon</label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="+90 (555) 123 45 67"
                />
              </div>
              <div className="form-field">
                <label>WhatsApp</label>
                <input
                  type="tel"
                  name="whatsappNumber"
                  value={formData.whatsappNumber}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="+90 (555) 123 45 67"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-field">
                <label>E-posta</label>
                <input
                  type="email"
                  name="mailTo"
                  value={formData.mailTo}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="info@example.com"
                />
              </div>
              <div className="form-field">
                <label>Konum / Adres</label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="İstanbul, Türkiye"
                />
              </div>
            </div>
          </div>

          {/* Sosyal Medya Ayarları */}
          <div className="content-card full-width">
            <div className="card-section-header">
              <Share2 size={20} />
              <h3>Sosyal Medya</h3>
            </div>

            {[
              {
                toggle: "isInstagramOn",
                url: "instagramUrl",
                label: "Instagram",
                placeholder: "https://instagram.com/hesabiniz",
              },
              {
                toggle: "isFacebookOn",
                url: "facebookUrl",
                label: "Facebook",
                placeholder: "https://facebook.com/sayfaniz",
              },
              {
                toggle: "isTwitterOn",
                url: "twitterUrl",
                label: "Twitter / X",
                placeholder: "https://x.com/hesabiniz",
              },
              {
                toggle: "isLinkedinOn",
                url: "linkedinUrl",
                label: "LinkedIn",
                placeholder: "https://linkedin.com/in/profiliniz",
              },
              {
                toggle: "isYoutubeOn",
                url: "youtubeUrl",
                label: "YouTube",
                placeholder: "https://youtube.com/@kanaliniz",
              },
              {
                toggle: "isTiktokOn",
                url: "tiktokUrl",
                label: "TikTok",
                placeholder: "https://tiktok.com/@hesabiniz",
              },
              {
                toggle: "isGithubOn",
                url: "githubUrl",
                label: "GitHub",
                placeholder: "https://github.com/hesabiniz",
              },
              {
                toggle: "isBehanceOn",
                url: "behanceUrl",
                label: "Behance",
                placeholder: "https://behance.net/hesabiniz",
              },
              {
                toggle: "isDribbbleOn",
                url: "dribbbleUrl",
                label: "Dribbble",
                placeholder: "https://dribbble.com/hesabiniz",
              },
              {
                toggle: "isDiscordOn",
                url: "discordUrl",
                label: "Discord",
                placeholder: "https://discord.gg/davetlinki",
              },
              {
                toggle: "isMediumOn",
                url: "mediumUrl",
                label: "Medium",
                placeholder: "https://medium.com/@hesabiniz",
              },
              {
                toggle: "isPinterestOn",
                url: "pinterestUrl",
                label: "Pinterest",
                placeholder: "https://pinterest.com/hesabiniz",
              },
              {
                toggle: "isSkypeOn",
                url: "skypeUrl",
                label: "Skype",
                placeholder: "skype:kullaniciadi",
              },
              {
                toggle: "isTelegramOn",
                url: "telegramUrl",
                label: "Telegram",
                placeholder: "https://t.me/hesabiniz",
              },
              { toggle: "isWhatsappOn", label: "WhatsApp (ikon göster)" },
            ].map((item) => (
              <div className="social-media-row" key={item.toggle}>
                <div className="form-field">
                  <label className="toggle-label">
                    <span>{item.label}</span>
                    <label className="toggle">
                      <input
                        type="checkbox"
                        name={item.toggle}
                        checked={formData[item.toggle]}
                        onChange={handleChange}
                      />
                      <span className="toggle-slider" />
                    </label>
                  </label>
                </div>
                {item.url && (
                  <div className="form-field" style={{ flex: 1 }}>
                    <input
                      type="text"
                      name={item.url}
                      value={formData[item.url]}
                      onChange={handleChange}
                      className="form-input"
                      placeholder={item.placeholder}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? (
              <>
                <Loader2 size={18} className="spin" /> Kaydediliyor...
              </>
            ) : (
              <>
                <Save size={18} /> Kaydet
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
